var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWormhole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_270)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.6066,
    y: 8.5332,
    width: 49.7,
    height: 49.7,
    rx: 24.85,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0466 39.9057C44.084 41.5808 42.3028 42.6108 40.3725 42.6108H37.2508V32.0845L32.7452 39.9082C31.7825 41.5831 30.0014 42.6132 28.0711 42.6132H24.971V27.0788H31.2072V37.5786L37.2508 27.0836V27.0788H43.4846V37.622L50.0337 26.2437C50.2985 25.7817 50.2936 25.2089 50.0072 24.7589C46.9867 19.9891 41.6313 16.8437 35.5468 16.9352C26.2683 17.0796 18.9587 24.5471 19.0068 33.8245C19.055 43.0608 26.5596 50.5332 35.8067 50.5332C45.0538 50.5332 52.6066 43.0126 52.6066 33.7354C52.6066 32.2409 52.4093 30.7922 52.0411 29.4108C51.9303 28.992 51.3719 28.915 51.1552 29.288L45.0443 39.9034L45.0466 39.9057Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_270",
    x: 0.106567,
    y: 0.833203,
    width: 70.7,
    height: 70.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_270",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_270"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.0066,
    y: 16.9332,
    width: 33.6,
    height: 33.6,
    rx: 16.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWormhole);
export default __webpack_public_path__ + "static/media/wormhole.65cabe731d00b81aa6895d6be3f8b7ea.svg";
export { ForwardRef as ReactComponent };